module.exports = __webpack_public_path__ + "img/logo2x.ea55090a.svg";